/**
 * Build a query string from a params object, filtering out undefined/null/empty values.
 *
 * @param params - Object with string, number, boolean, null, or undefined values
 * @returns Query string (without leading '?')
 *
 * @example
 * buildQueryString({ status: 'active', page: 1, empty: '', nullVal: null })
 * // Returns: "status=active&page=1"
 */
export function buildQueryString(
  params: Record<string, string | number | boolean | null | undefined>
): string {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, String(value));
    }
  });
  return searchParams.toString();
}
